// extracted by mini-css-extract-plugin
module.exports = {"kidsAccountNavWrapper":"yA","hidden":"yB","menuBackground":"yC","avatar":"yD","header":"yE","accountNavAvatar":"yF","buttonPlaceholder":"yG","accountLinks":"yH","accountLink":"yI"};